module.exports = __webpack_public_path__ + "img/logo_202.dddbda66.svg";